export default {
	setContent(state, payload) {
		state.content = payload
	},
	loading(state, payload) {
		state.loading = payload
	},
};
